export default __webpack_public_path__ + "static/media/full_TheShadowsofDust.0a1ba7df.jpg";